import $ from 'jquery';

export default class {
	constructor(options) {
		const defaults = {
			el: '#yotaConnectSim',
			dom: {
				form: '#yotaConnectSimForm',
				quantity: '#yotaConnectSimQuantity',
				mnp: '#yotaConnectSimMnp',
				transfer: '.js-connect-sim-transfer',
				transferBox: '.js-connect-sim-transfer-box'

			},
			classes: {
				mnp: 'b-connect-sim_state_mnp'
			},
			data: {
				quantity: 0,
				mnp: false
			}
		};
		this.options = $.extend(true, {}, defaults, options);
		this.data = this.options.data;
		this.$el = (this.options.el instanceof $) ? this.options.el : $(this.options.el);
		this.$window = $(window);
		return this;
	}

	getDom() {
		this.$form = this.$el.find(this.options.dom.form);
		this.$quantity = this.$el.find(this.options.dom.quantity);
		this.$mnp = this.$el.find(this.options.dom.mnp);
		this.$transfer = this.$el.find(this.options.dom.transfer);
		this.$transferBox = this.$el.find(this.options.dom.transferBox);
		return this;
	}

	onQuantity(event) {
		const {max, min} = this.$quantity.data();
		const def = this.$quantity.data('default');
		const value = this.$quantity.val();
		let quantity = value.replace(/[^\d]/ig, '').replace(/^0/ig, '');
		if (quantity != '' && event.type != 'blur') {
			if (quantity > max) {
				quantity = max;
			}
			if (quantity < min) {
				quantity = min;
			}
		}
		if (quantity == '' && event.type == 'blur') {
			quantity = def;
		}
		if (quantity != value) {
			event.currentTarget.value = quantity;
		}
		if (['change', 'blur'].indexOf(event.type) >= 0) {
			this.data.quantity = parseInt(quantity);
			this.$window.trigger('yota.connect.transfer.quantity', this.data.quantity);
			this.toggle();
		}
		return this;
	}

	onMnp() {
		this.data.mnp = this.$mnp.filter(':checked').length > 0;
		this.toggle();
		this.$window.trigger('yota.connect.transfer.quantity', this.data.mnp ? this.data.quantity : 0);
		return this;
	}

	toggle() {
		this.$el.toggleClass(this.options.classes.mnp, this.data.mnp && this.data.quantity > 0);
		this.onTransferResize();
		return this;
	}

	get() {
		const data = this.$form.serializeArray();
		const json = {};
		$.each(data, function (key, val) {
			json[val.name] = val.value;
		});
		return JSON.stringify(json);
	}

	onTransferResize() {
		let height = 0;
		if (this.$el.hasClass(this.options.classes.mnp)) {
			height = this.$transferBox.outerHeight(true);
		}
		this.$transfer.css({height});
		return this;
	}

	update(data) {
		if (typeof data !== 'undefined') {
			this.data = data;
		}

		this.$quantity.val(this.data.quantity !== 0 ? this.data.quantity : '');
		this.$mnp.prop('checked', this.data.mnp);
		this.$window.trigger('yota.connect.transfer.quantity', this.data.quantity);
		this.toggle();
		return this;
	}

	setQuantity(value) {
		this.$quantity.val(value);
	}

	onSubmit(event) {
		this.$quantity.blur();
		event.preventDefault();
	}

	render() {
		if (this.$el.length) {
			this
				.getDom()
				.update();

			this.$quantity.on('input keyup paste change blur', this.onQuantity.bind(this));
			this.$mnp.on('change click', this.onMnp.bind(this));
			this.$window.on('yota.connect.transfer.resize', this.onTransferResize.bind(this));
			this.$form.on('submit', this.onSubmit.bind(this));
		}
		return this;
	}
}



// WEBPACK FOOTER //
// ./app/portlets/site/connect/sim/sim.js